export default {
  topicsLoaded(state) {
    return state.topicsLoaded;
  },
  subCategories(state) {
    return state.subCategories;
  },
  categories(state) {
    return state.categories;
  },
  categoryNames(state) {
    var response = [];
    state.categories.forEach((category) => {
      response.push(category.name);
    });
    return response;
  },
  content(state) {
    return state.content;
  },
  topics(state) {
    return state.topics;
  },
};
